module.exports = __webpack_public_path__ + "17f753ab5d7a960e788551023d83fa42.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/salesApp/home-icon.svg
// module id = cCNn
// module chunks = 459